import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PopupLoginError from '../../../components/Popup/LoginError';
import useIdentityVerification from '../../../hooks/useIdentityVerification';
import usePopupStore from '../../../store/popupStore';
import { ID_FIND_URL } from '../../../utils/urls';
import instance from '../../../services/services';
import { useLanguage } from '../../../hooks/useLanguage';   

function IdFind() {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const { showAlert } = usePopupStore();
    const[isPopupLoginError, setIsPopupLoginError] = useState(""); // 에러 팝업
    const [isAuthenticated, setIsAuthenticated] = useState({
        show: false,
        success: false
    });
    const [foundId, setFoundId] = useState(""); // API 응답에서 받아올 아이디 값

    // // 본인인증 결과 처리 핸들러
    // const handleAuthResult = async (response) => {
    //     try {

    //         if (!response || response.trim() === "") {
    //             throw new Error("본인 인증 응답이 비어 있습니다.");
    //         }

    //         if (!response.startsWith("{") && !response.startsWith("[")) {
    //             console.warn("서버에서 JSON이 아닌 데이터를 반환했습니다:", response);
    //             showAlert({
    //                 text: "서버에서 올바른 응답을 받지 못했습니다. 다시 시도해주세요.",
    //                 closeButton: "확인"
    //             });
    //             return;
    //         }

    //         const data = JSON.parse(response);

    //         if (data.resultCode === "200") {
    //             try {
    //                 // 본인인증에서 받은 휴대폰 번호로 아이디 찾기 API 호출
    //                 const response = await instance.post(ID_FIND_URL, {
    //                     mem_phone: data.mem_phone  // 본인인증에서 받은 휴대폰 번호
    //                 });

    //                 // API 응답 구조에 맞게 처리
    //                 if (response.data.code === 200) {
    //                     // 성공: 아이디를 찾은 경우
    //                     setFoundId(response.data.data.userid); // 실제 응답 구조에 맞게 수정 필요
    //                     setIsAuthenticated({
    //                         show: true,
    //                         success: true
    //                     });
    //                 } else if (response.data.code === -200) {
    //                     // 실패: 계정을 찾을 수 없는 경우
    //                     setIsAuthenticated({
    //                         show: true,
    //                         success: false
    //                     });
    //                     showAlert({
    //                         text: response.data.message || "입력하신 정보와 일치하는 계정이 없습니다.",
    //                         closeButton: "확인"
    //                     });
    //                 } else {
    //                     // 기타 에러
    //                     setIsAuthenticated({
    //                         show: true,
    //                         success: false
    //                     });
    //                     showAlert({
    //                         text: response.data.message || "알 수 없는 오류가 발생했습니다.",
    //                         closeButton: "확인"
    //                     });
    //                 }
    //             } catch (error) {
    //                 console.error("아이디 찾기 API 호출 실패:", error);
    //                 setIsAuthenticated({
    //                     show: true,
    //                     success: false
    //                 });
    //                 showAlert({
    //                     text: "아이디 찾기에 실패했습니다. 다시 시도해주세요.",
    //                     closeButton: "확인"
    //                 });
    //             }
    //         } else if (data.resultCode === "-200") {
    //             showAlert({
    //                 text: data.resultMsg || "인증에 실패했습니다.",
    //                 closeButton: "확인"
    //             });
    //             setIsAuthenticated({
    //                 show: true,
    //                 success: false
    //             });
    //         } else {
    //             showAlert({
    //                 text: "알 수 없는 오류가 발생했습니다. 다시 시도해주세요.",
    //                 closeButton: "확인"
    //             });
    //             console.warn("예상치 못한 본인 인증 응답:", data);
    //         }
    //     } catch (error) {
    //         console.error("본인인증 결과 처리 중 오류:", error);
    //         showAlert({
    //             text: "본인 인증 처리 중 오류가 발생했습니다.",
    //             closeButton: "확인"
    //         });
    //         setIsAuthenticated({
    //             show: true,
    //             success: false
    //         });
    //     }
    // };

    // 본인인증 훅 사용
    const { handleIdentity } = useIdentityVerification({
        context: 'IdFind'  // 아이디 찾기용 컨텍스트
    });

    useEffect(() => {
        // ID 찾기 함수를 useEffect 안으로 이동
        const findIdWithPhone = async (phone) => {
            try {
                const response = await instance.post(ID_FIND_URL, {
                    mem_phone: phone
                });
                
                if (response.data.code === 200) {
                    setFoundId(response.data.data.userid);
                    setIsAuthenticated({
                        show: true,
                        success: true
                    });
                } else {
                    setIsAuthenticated({
                        show: true,
                        success: false
                    });
                    showAlert({
                        text: response.data.message || "입력하신 정보와 일치하는 계정이 없습니다.",
                        closeButton: "확인"
                    });
                }
            } catch (error) {
                console.error("아이디 찾기 API 호출 실패:", error);
                // 에러 처리
            }
        };

        const params = new URLSearchParams(window.location.search);
        const verified = params.get('verified');
        
        if (verified === 'true') {
            // localStorage에서 인증 정보 가져오기
            const authInfoStr = localStorage.getItem('authVerificationInfo');
            if (authInfoStr) {
                const authInfo = JSON.parse(authInfoStr);
                // 인증 정보 활용하여 아이디 찾기 API 호출
                findIdWithPhone(authInfo.mem_phone);
                // 사용 후 삭제
                localStorage.removeItem('authVerificationInfo');
            }
        }
    }, [showAlert]);  // showAlert 의존성 추가

    return (
        <section className="auth_section">
            <div className="inner">
                <div className="section_title">
                    <h3>{t("account_find")}</h3>
                </div>
                
                <div className="find_wrap">
                    <div className="tab_menu">
                        <Link to="/auth/find/id" className="tab_item active">{t("id")}</Link>
                        <Link to="/auth/find/password" className="tab_item">{t("password")}</Link>
                    </div>
                    
                    <div className="find_content">
                        {!isAuthenticated.show ? (
                            // 초기 화면 (휴대폰 인증)
                            <>
                                <p className="accession_text">{t("check_id_with_phone")}</p>
                                <div className="auth_btn_wrap">
                                    <button 
                                        type="button" 
                                        className="default_btn black lg w-100"
                                        onClick={handleIdentity}
                                    >
                                        {t("verify_identity")}
                                    </button>
                                </div>
                            </>
                        ) : isAuthenticated.success ? (
                            // 계정 찾기 성공
                            <div className="result_wrap">
                                <p className="accession_text">{t("existing_account_found")}</p>
                                <p className="sub_guide_text">{t("login_with_existing_account")}</p>
                                
                                <div className="found_id_box">
                                    {foundId}
                                </div>
                                
                                <div className="btn_group_4">
                                    <button type="button" className="default_btn white lg" onClick={() => navigate('/auth/find/password')}>
                                        {t("find_password")}
                                    </button>
                                    <button type="button" className="default_btn black lg" onClick={() => navigate('/login')}>
                                    {t("login")}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            // 계정찾기 실패
                            <div className="result_wrap">
                                <p className="accession_text">{t("cannot_find_account")}</p>
                                <p className="sub_guide_text">
                                    {t("account_deleted_or_not_exist")}<br/>
                                    {t("check_info_again")}
                                </p>
                                
                                <div className="btn_group_4">
                                    <button type="button" className="default_btn white lg" onClick={() => navigate('/auth/find/id')}>
                                    {t("find_account_again")}
                                    </button>
                                    <button type="button" className="default_btn black lg" onClick={() => navigate('/joinAgreement')}>
                                    {t("sign_up_button")}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            {/* NICE 인증을 위한 숨겨진 폼 */}
            <form 
                id="niceAuthForm" 
                name="niceAuthForm" 
                action="https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb"
                method="post"
                style={{ display: 'none' }}
            >
                <input type="hidden" id="m" name="m" value="service" />
                <input type="hidden" id="token_version_id" name="token_version_id" value="" />
                <input type="hidden" id="enc_data" name="enc_data" value="" />
                <input type="hidden" id="integrity_value" name="integrity_value" value="" />
                <input type="hidden" id="receivedata" name="receivedata" value="" />
            </form>
            </div>
            <PopupLoginError isPopup={isPopupLoginError} setIsPopup={setIsPopupLoginError}/>
        </section>
    );
}

export default IdFind;
